



























































































































import {
  Vue,
  Component,
  Prop,
  Emit
} from 'vue-property-decorator';
import CardMoreButton from '@/components/CardMoreButton.vue'
import { meetingStatus, trialStatus } from '@/config/dic'
import apis from '@/apis/trailing';

const trialShowStatus = {
  unTrial: '即将开庭',
  preparing: '预备开庭',
  trialing: '庭审中',
  adjourned: '休庭中',
  adjourning: '休庭中'
};

@Component({
  components: {
    CardMoreButton
  }
})
export default class TodayCard extends Vue {
  @Prop({ required: true }) readonly info: any

  @Prop({ required: true }) readonly index: number

  @Prop({ required: true }) readonly listLength: number

  private joinLoading: boolean = false

  private get isArbitration(): boolean {
    return this.$store.getters.tribunalType === 'arbitration'
  }

  private get userId(): string {
    return this.$store.getters.userInfo.userId
  }

  private get thirdShowList(): Array< object > {
    if (!this.info.thirds) {
      return []
    }
    if (this.info.thirds.length > this.showMaxNumber) {
      return this.info.thirds.slice(0, 3)
    }
    return this.info.thirds
  }

  private get defendantShowList(): Array< object > {
    if (!this.info.defendants) {
      return []
    }
    if (this.info.defendants.length > this.showMaxNumber) {
      return this.info.defendants.slice(0, 3)
    }
    return this.info.defendants
  }

  private get plaintiffShowList(): Array< object > {
    if (!this.info.plaintiffs) {
      return []
    }
    if (this.info.plaintiffs.length > this.showMaxNumber) {
      return this.info.plaintiffs.slice(0, 3)
    }
    return this.info.plaintiffs
  }

  private get trialShowStatus(): string {
    if (this.info.trialStatus === trialStatus.unTrial && this.info.meetingStatus === meetingStatus.open) {
      return '庭审准备中'
    }
    return trialShowStatus[this.info.trialStatus]
  }

  private get showNameMap(): Store.showNameMap {
    return this.$store.getters.showNameMap
  }

  private get isShowOpenId(): Boolean {
    // const trial = this.info.trialStatus === 'trialing'
    const meeting = this.info.meetingStatus === 'open'
    return meeting
  }

  // 展示更多按钮的事件名称
  private get eventList(): Array<string> {
    console.log('info', this.info)
    if (this.info.synType === 'syned') {
      return ['caseDetail']
    }
    let eventList: Array<string> = ['caseDetail', 'uploadEvidence']
    if (this.info.trialStatus === trialStatus.unTrial && this.info.meetingStatus === meetingStatus.unCreate) {
      eventList = eventList.concat(['editCase', 'delPlanCase', 'resetPlan', 'cancelPlan'])
    }
    return eventList
  }

  // 最多展示照片数
  private showMaxNumber: number = 3

  // 当前卡片处于的位置
  private get indexPosition(): string {
    if (this.listLength > 1) {
      if (this.index === 0) {
        return 'left'
      } if (this.index === this.listLength - 1) {
        return 'right'
      }
      return 'middle'
    }
    return ''
  }

  @Emit('courtTrial')
  onCourtTrial() {
    this.joinLoading = true
    if (this.info.meetingStatus !== meetingStatus.open) {
      const params = {
        scheduleId: this.info.scheduleId,
        tribunalId: this.info.tribunalId,
        corpId: this.$store.getters.userInfo.corpId,
        caseId: this.info.caseId,
        userId: this.info.chiefJudgeId
      }
      apis.startConference(params).then(res => {
        this.joinLoading = false
        this.$router.push(`/index/trialing/${this.info.scheduleId}`)
      }).catch(err => {
        // 判断当前法庭是否被占用
        if (err.code === '504') {
          this.$msgbox({
            title: '进入庭审失败',
            type: 'warning',
            message: err.msg
          })
        }
        this.joinLoading = false
      })
    } else {
      this.$router.push(`/index/trialing/${this.info.scheduleId}`)
    }
  }

  @Emit('onAgainSchedule')
  onAgainSchedule() {}

  @Emit('onCancelScheduleSuccess')
  onCancelScheduleSuccess() {}

  @Emit('onDeleteCasePlanSuccess')
  onDeleteCasePlanSuccess() {}
}
